import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import BadgesList from './BadgesList';

function Badges(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderBagdes = () => {
    const badges = loadBadges();
    if (badges) {
      return (
        <div className="row">
          <BadgesList badges={badges} />
        </div>
      );
    }
  };

  const loadBadges = () => {
    const { badges } = props;
    if (badges) {
      let badgesList = [];
      for (var key in badges) {
        var value = { ...badges[key] };
        value.id = key;
        if (value.type === 'SAFETY') badgesList.push(value);
      }
      return badgesList;
    }
  };

  return (
    <div className="dashboard container">
      {renderBagdes()}
      <Link className="btn-floating btn-large fixed-action-btn green right" to="newBadge">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    badges: state.firestore.data.badges,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([{ collection: 'badges' }]))(Badges);
